import { Component, Input } from "@angular/core";
import { ExpandNavV2Service } from "@gtmhub/navigation/expand-nav-v2.service";

@Component({
  selector: "gh-toggle-nav",
  templateUrl: "./toggle-nav.component.html",
  styleUrls: ["./toggle-nav.component.less"],
})
export class ToggleNavComponent {
  @Input()
  action: "expand" | "collapse";

  constructor(private expandNavV2Service: ExpandNavV2Service) {}

  public expandNav(value: boolean): void {
    this.expandNavV2Service.setIsNavExpanded(value);
  }
}
